import tokenData from '../../design-tokens/base-tokens.json';
export const MuiButton = {
    defaultProps: {
        disableFocusRipple: true
    },
    styleOverrides: {
        root: {
            fontWeight: 600,
            borderRadius: '6px',
            minWidth: 'unset',
            textTransform: 'none',
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled
            },
            '&:hover, &.Mui-focusVisible': {
                '& .MuiAvatar-colorDefault': {
                    background: tokenData.tokens.palette.blue.blue600
                },
                '& .MuiAvatar-alt': {
                    background: tokenData.tokens.palette.blue.blue100
                }
            },
            '& .MuiButton-startIcon': {
                marginLeft: -2,
                marginRight: 4
            }
        },
        contained: {
            boxShadow: '0px 2px 1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12)',
            '&.Mui-disabled': {
                backgroundColor: tokenData.tokens.palette.grey.disabled,
                color: tokenData.tokens.palette.background.white,
                pointerEvents: 'unset',
                cursor: 'not-allowed',
                '&:hover': {
                    backgroundColor: tokenData.tokens.palette.grey.disabled,
                    color: tokenData.tokens.palette.background.white
                }
            },
            '&[aria-disabled="true"]': {
                backgroundColor: tokenData.tokens.palette.grey.disabled,
                color: tokenData.tokens.palette.background.white,
                pointerEvents: 'unset',
                cursor: 'not-allowed',
                '&:hover': {
                    backgroundColor: tokenData.tokens.palette.grey.disabled,
                    color: tokenData.tokens.palette.background.white
                }
            }
        },
        containedPrimary: {
            '&.Mui-focusVisible': {
                backgroundColor: tokenData.tokens.palette.blue.blue600,
                outlineOffset: '2px',
                outlineStyle: 'solid',
                outlineWidth: '2px',
                outlineColor: tokenData.tokens.palette.text.text300,
                boxShadow: 'none'
            }
        },
        outlinedPrimary: {
            '&.Mui-focusVisible': {
                backgroundColor: 'rgba(16, 116, 195, 0.12)',
                color: tokenData.tokens.palette.blue.blue600,
                outlineOffset: '3px',
                outlineStyle: 'solid',
                outlineWidth: '2px',
                outlineColor: tokenData.tokens.palette.text.text300
            }
        },
        textPrimary: {
            '&:hover, &.Mui-focusVisible': {
                color: tokenData.tokens.palette.blue.blue600,
                '& .MuiAvatar-colorDefault': {
                    background: tokenData.tokens.palette.blue.blue600
                },
                '& .MuiAvatar-alt': {
                    background: tokenData.tokens.palette.blue.blue100
                }
            },
            '&[aria-expanded="true"]': {
                color: tokenData.tokens.palette.blue.blue600,
                '& .MuiAvatar-colorDefault': {
                    background: tokenData.tokens.palette.blue.blue600
                },
                '& .MuiAvatar-alt': {
                    background: tokenData.tokens.palette.blue.blue100
                }
            }
        },
        outlined: {
            '&:hover': {
                backgroundColor: 'rgba(16, 116, 195, 0.04)',
                color: tokenData.tokens.palette.blue.blue600
            },
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled,
                borderColor: tokenData.tokens.palette.grey.disabled,
                pointerEvents: 'unset',
                cursor: 'not-allowed',
                '&:hover': {
                    color: tokenData.tokens.palette.grey.disabled,
                    backgroundColor: tokenData.tokens.palette.background.white
                }
            },
            '&[aria-disabled="true"]': {
                color: tokenData.tokens.palette.grey.disabled,
                pointerEvents: 'unset',
                cursor: 'not-allowed',
                borderColor: tokenData.tokens.palette.grey.disabled,
                '&:hover': {
                    color: tokenData.tokens.palette.grey.disabled,
                    backgroundColor: tokenData.tokens.palette.background.white
                }
            }
        },
        text: {
            color: tokenData.tokens.palette.blue.blue500,
            '&[aria-disabled="true"]': {
                color: tokenData.tokens.palette.grey.disabled,
                pointerEvents: 'unset',
                cursor: 'not-allowed',
                '&:hover': {
                    color: tokenData.tokens.palette.grey.disabled,
                    backgroundColor: 'transparent'
                }
            },
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled,
                pointerEvents: 'unset',
                cursor: 'not-allowed',
                '&:hover': {
                    color: tokenData.tokens.palette.grey.disabled,
                    backgroundColor: 'transparent'
                }
            },
            '&.Mui-focusVisible': {
                backgroundColor: 'rgba(16, 116, 195, 0.12)',
                outlineStyle: 'solid',
                outlineWidth: '2px',
                outlineColor: tokenData.tokens.palette.text.text300
            },
            '&:hover': {
                backgroundColor: 'rgba(16, 116, 195, 0.12)'
            }
        },
        sizeSmall: ({ theme }) => ({
            padding: theme.spacing(2, 4),
            '&.MuiButton-outlined': {
                padding: theme.spacing(1.5, 3.5),
            },
            ...theme.typography.labelSm,
            '& .label': tokenData.tokens.typography.label,
            '& .MuiButton-startIcon': {
                '*:nth-of-type(1)': {
                    fontSize: 16
                }
            },
            '& .MuiButton-endIcon': {
                '*:nth-of-type(1)': {
                    fontSize: 16
                }
            }
        }),
        sizeMedium: ({ theme }) => ({
            padding: theme.spacing(2, 4),
            '&.MuiButton-outlined': {
                padding: theme.spacing(1.5, 3.5),
            },
            ...theme.typography.label,
            '& .MuiButton-startIcon': {
                '*:nth-of-type(1)': {
                    fontSize: 18
                }
            },
            '& .MuiButton-endIcon': {
                '*:nth-of-type(1)': {
                    fontSize: 18
                }
            }
        }),
        sizeLarge: ({ theme }) => ({
            padding: theme.spacing(3, 6),
            '&.MuiButton-outlined': {
                padding: theme.spacing(2.5, 5.5),
            },
            ...theme.typography.labelLg,
            '& .label': tokenData.tokens.typography.label,
            '& .MuiButton-startIcon': {
                '*:nth-of-type(1)': {
                    fontSize: 20
                }
            },
            '& .MuiButton-endIcon': {
                '*:nth-of-type(1)': {
                    fontSize: 20
                }
            }
        })
    }
};
export const MuiIconButton = {
    defaultProps: {
        disableFocusRipple: true,
        disableRipple: true
    },
    variants: [
        {
            props: { variant: 'outlined' },
            style: ({ theme }) => ({
                padding: theme.spacing(1.5),
                border: `1px solid ${tokenData.tokens.palette.blue.blue500}`,
                color: tokenData.tokens.palette.blue.blue500,
                '&:hover': {
                    color: tokenData.tokens.palette.darkBlue.darkBlue700,
                    border: `1px solid ${tokenData.tokens.palette.darkBlue.darkBlue300}`,
                    background: tokenData.tokens.palette.darkBlue.darkBlue100
                },
                '&.Mui-disabled': {
                    background: 'transparent',
                    color: tokenData.tokens.palette.grey.disabled,
                    borderColor: tokenData.tokens.palette.grey.disabled
                },
                '&.MuiIconButton-sizeLarge': {
                    padding: theme.spacing(2.5)
                }
            })
        }
    ],
    styleOverrides: {
        root: ({ theme }) => ({
            color: tokenData.tokens.palette.darkBlue.darkBlue600,
            padding: theme.spacing(2),
            borderRadius: 6,
            '&:hover, &.Mui-focusVisible': {
                background: tokenData.tokens.palette.darkBlue.darkBlue100,
                color: tokenData.tokens.palette.darkBlue.darkBlue700
            },
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled,
                background: 'transparent',
                pointerEvents: 'unset',
                cursor: 'not-allowed'
            },
            '&.Mui-focusVisible': {
                outline: `2px solid ${tokenData.tokens.palette.text.text300}`,
                outlineOffset: '2px'
            }
        }),
        sizeLarge: ({ theme }) => ({
            padding: theme.spacing(3)
        }),
        colorPrimary: {
            background: tokenData.tokens.palette.blue.blue500,
            color: tokenData.tokens.palette.background.white,
            '& .MuiSvgIcon-root': {
                color: tokenData.tokens.palette.background.white
            },
            '&:hover, &.Mui-focusVisible': {
                background: tokenData.tokens.palette.blue.blue600
            },
            '&.Mui-disabled': {
                background: tokenData.tokens.palette.grey.disabled,
                color: tokenData.tokens.palette.background.white
            }
        }
    }
};
export const MuiButtonGroup = {
    defaultProps: {
        disableElevation: true,
        disableFocusRipple: true
    },
    styleOverrides: {
        root: ({ theme }) => ({
            '& .MuiButton-sizeSmall:first-of-type': {
                '&.MuiButtonGroup-groupedHorizontal': {
                    borderRight: '0px'
                },
                '&.MuiButtonGroup-groupedVertical': {
                    borderBottom: '0px'
                },
                '&.Mui-focusVisible': {
                    zIndex: 1
                }
            },
            '& .MuiButton-sizeMedium:first-of-type': {
                '&.MuiButtonGroup-groupedHorizontal': {
                    borderRight: '0px'
                },
                '&.MuiButtonGroup-groupedVertical': {
                    borderBottom: '0px'
                },
                '&.Mui-focusVisible': {
                    zIndex: 1
                }
            },
            '& .MuiButton-sizeLarge:first-of-type': {
                '&.MuiButtonGroup-groupedHorizontal': {
                    borderRight: '0px'
                },
                '&.MuiButtonGroup-groupedVertical': {
                    borderBottom: '0px'
                },
                '&.Mui-focusVisible': {
                    zIndex: 1
                }
            },
            '& .MuiButton-root:last-child': {
                '&.MuiButton-contained': {
                    '&.MuiButton-sizeSmall': {
                        padding: theme.spacing(2)
                    },
                    '&.MuiButton-sizeMedium': {
                        padding: theme.spacing(2)
                    },
                    '&.MuiButton-sizeLarge': {
                        padding: theme.spacing(3)
                    },
                    '&:hover': {
                        backgroundColor: tokenData.tokens.palette.blue.blue600
                    },
                    '&.Mui-disabled': {
                        '&:hover': {
                            backgroundColor: tokenData.tokens.palette.grey.disabled,
                            color: tokenData.tokens.palette.text.text300
                        }
                    }
                },
                '&.MuiButton-outlined': {
                    '&.MuiButton-sizeSmall': {
                        padding: theme.spacing(1.5)
                    },
                    '&.MuiButton-sizeMedium': {
                        padding: theme.spacing(1.5)
                    },
                    '&.MuiButton-sizeLarge': {
                        padding: theme.spacing(2.5)
                    },
                    '&.Mui-disabled': {
                        '&:hover': {
                            backgroundColor: tokenData.tokens.palette.background.white,
                            color: tokenData.tokens.palette.grey.disabled
                        }
                    }
                }
            }
        }),
        contained: {
            '& .MuiButton-root': {
                '&.Mui-disabled': {
                    color: tokenData.tokens.palette.text.text300,
                    '&:hover': {
                        color: tokenData.tokens.palette.text.text300
                    }
                }
            }
        }
    }
};
export default MuiButton;
